module.exports = __webpack_public_path__ + "img/MercadoLibre.66d213c7.jpg";